/* Text layout inside palette rows; the row itself is a MUI ListItemButton. */
.title {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.title mark {
  background: transparent;
  color: var(--focus);
  font-weight: 600;
}

.subtitle {
  color: var(--ink-faint);
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
